import { refundMethods } from '@reveni-io/reveni-ui'

export const refundMethodOptions = [
  { value: refundMethods.storeCredit, labelKey: 'Crédito en tienda' },
  { value: refundMethods.giftCard, labelKey: 'Tarjeta regalo' },
  { value: refundMethods.originalPaymentMethod, labelKey: 'Método de pago original' },
]

export const methodsWithExtraCredit = [refundMethods.storeCredit, refundMethods.giftCard]
